import { Component, Inject, OnInit } from '@angular/core';
import { DocLibraryImplementAuditVM } from '../../../../../../../app/modules/GET_NEW_UI/entities/global/model';
import { DocumentLibraryService } from '../../../../../../../app/modules/GET_NEW_UI/services/document-library.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-document-adjustment-audit-trail',
  templateUrl: './document-adjustment-audit-trail.component.html',
  styleUrls: ['./document-adjustment-audit-trail.component.scss']
})
export class DocumentAdjustmentAuditTrailComponent implements OnInit {
  DocId: number;
  ImplementId: number;
  AuditResult:DocLibraryImplementAuditVM[];
  Title:string;
  constructor(private dialogRef: MatDialogRef<DocumentAdjustmentAuditTrailComponent>,
    @Inject(MAT_DIALOG_DATA) public data_: any,
    private _documentLibraryService: DocumentLibraryService) { }

  ngOnInit() {
    this.DocId = this.data_.DocId
    this.ImplementId = this.data_.ImplementId;

    this.LoadAuditForImplemetDoc();
  }

//LoadAudit

LoadAuditForImplemetDoc(){
  this._documentLibraryService.LoadAuditTrailForImplementDocument(this.DocId,this.ImplementId).subscribe(res=>{
    console.log("audit",res)
    this.AuditResult=res;
    this.Title = this.AuditResult[0].ImplementSerial + ' ' +  this.AuditResult[0].DocType
  })
}

OpenDoc(Attachment:string){
  var newstring = Attachment.slice(1);
  let _newstring = newstring.substring(0, newstring.length - 1);
  var arrBuffer = this.base64ToArrayBuffer(Attachment);
  var blob = new Blob([arrBuffer], { type: 'application/pdf' });
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = 'Doc_Attachment_.pdf';
  link.click();
}

base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}


  onCloseClick(): void {
    this.dialogRef.close();
  }
}
